import { Modal, Typography } from "antd";
import PrimaryButton from "../CustomButton/PrimaryButton";
import successGif from "../../assets/images/success.gif";

const { Title, Text } = Typography;

const SuccessConfirmationModal = ({
  open,
  onClose,
  title,
  description,
  buttonLabel = "OK",
}) => (
  <Modal
    open={open}
    footer={null}
    closable={false}
    centered
    width={600}
    maskClosable={false}
  >
    <div style={{ textAlign: "center", padding: "20px" }}>
      <img
        src={successGif}
        alt="Success"
        style={{
          width: "400px",
          height: "200px",
          objectFit: "contain",
        }}
      />
      <Title level={3}>{title}</Title>
      <Text
        style={{
          fontSize: "16px",
          color: "#666",
          display: "block",
          marginBottom: "24px",
        }}
      >
        {description}
      </Text>
      <PrimaryButton onClick={onClose}>{buttonLabel}</PrimaryButton>
    </div>
  </Modal>
);

export default SuccessConfirmationModal;
